import { FormResponseData } from './user.service';
import fetcher from 'utils/helpers/browser/fetcher';
import {
    default as newFetcher,
    MethodEnum,
} from 'utils/helpers/browser/newFetcher';

import {
    CompetitionYearInterface,
    Option,
} from 'components/interfaces/GeneralInterface';
import { getDiscipline } from 'utils/helpers/browser/discipline';
import { QueryRequestInterface } from 'submodules/api_middleware/src/interfaces/InternalInterfaces';
import { ClubBaseWithDisciplineApiInterface } from 'submodules/api_middleware';

export const getUserClubsList = async (
    query: QueryRequestInterface = {}
): Promise<Option[]> => {
    return await fetcher('/api/list/user/clubs', 'GET', {
        discipline: getDiscipline(),
        ...query,
    }).then((response) => {
        return Object.values(response.data.data)
            .reduce((result: ClubBaseWithDisciplineApiInterface[], value) => {
                (value as ClubBaseWithDisciplineApiInterface[]).forEach(
                    (club) => {
                        if (!result.some((r) => r.id === club.id)) {
                            result.push(club);
                        }
                    }
                );
                return result;
            }, [])
            .map((key: { id: number; name: string }) => ({
                value: key.id,
                label: key.name,
            }))
            .sort((a: Option, b: Option) => a.label.localeCompare(b.label));
    });
};

export const getCountriesList = async (): Promise<CountriesListResponse> => {
    return await newFetcher('/api/list/countries', MethodEnum.GET);
};

export interface CountriesListResponse {
    data: CountriesListResponseData;
}

export interface CountriesListResponseData {
    values: CountryItem[];
}

export interface CountryItem {
    name: string;
}

export const getLanguagesList = async (): Promise<LanguagesListResponse> => {
    return await newFetcher('/api/list/languages', MethodEnum.GET);
};

export interface LanguagesListResponse {
    data: LanguagesListResponseData;
}

export interface LanguagesListResponseData {
    values: LanguageItem[];
}

export interface LanguageItem {
    name: string;
}

export const getCompetitionYears = async (): Promise<
    CompetitionYearInterface[]
> => {
    return (
        (await newFetcher('/api/list/competition_years', MethodEnum.GET, {
            discipline: getDiscipline(),
        })) as FormResponseData
    ).data as CompetitionYearInterface[];
};
